import axios from "axios";

const host = process.env.REACT_APP_BASE_URL || "http://localhost:5000/api";

const createCheckoutSession = async (token) => {
  const response = await axios.post(
    `${host}/subscription/create-checkout-session`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

const verifyCheckoutSession = async (token, sessionId) => {
  const response = await axios.post(
    `${host}/subscription/verify-checkout-session`,
    { sessionId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

const completeRegistration = async (sessionId) => {
  const response = await axios.post(
    `${host}/subscription/complete-registration`,
    { sessionId }
  );
  return response.data;
};

const markAbandonedCheckout = async (pendingRegistrationId) => {
  const response = await axios.post(`${host}/subscription/abandoned-checkout`, {
    pendingRegistrationId,
  });
  return response.data;
};

const syncSubscriptionStatus = async (token) => {
  const response = await axios.post(
    `${host}/subscription/sync-status`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

const updateAutoRenew = async (token, autoRenew) => {
  const response = await axios.patch(
    `${host}/subscription/auto-renew`,
    { autoRenew },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

const cancelSubscription = async (token) => {
  const response = await axios.post(
    `${host}/subscription/cancel`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export default {
  createCheckoutSession,
  verifyCheckoutSession,
  completeRegistration,
  markAbandonedCheckout,
  syncSubscriptionStatus,
  updateAutoRenew,
  cancelSubscription,
};
